export default __webpack_public_path__ + "protichinta-colored.png";